export default "__VITE_ASSET__C6uW5rjA__"